// ------------------------------------------------------------------
// PURE MODULE: lazyload_advnc_dec.mod2.js
// ------------------------------------------------------------------
import gsap from "gsap"; 

export function LazyLoadModule() {

  /////////////////////// MODULE LOGIC START ///////////////////////

  const defaultConfig = {
    slideSelector: ".carousel-image",
    lazyClass: ".lazy",
    types: ["image", "video"],
    lookahead: 2,
    lookbehind: 3,
    bidirectional: true,
    removeDataAttr: true,
//    fadeInClass: "lazy-fadein",
    fadeInClass: "show",
    placeholderAttrLow: "data-src-low",
    highResAttr: "data-src",
    highResSrcsetAttr: "data-srcset",
    videoSourceAttr: "data-video-src",
    posterAttr: "data-poster", // Attribute for video poster
    preconnectOrigins: [],
    debug: false,
    loadDelay: 1000
  };

  let cfg = Object.assign({}, defaultConfig);
  let initialized = false;
  let slideCount = 0;
  let slides = [];
  let slideLazyMap = [];
  let loadedFlags = [];
  let lastProcessedTarget = null;
  let loadTimer = null; 

  function dlog(...args) {
    if (cfg.debug) console.log("[lazyload]", ...args);
  }

  function scanSlides() {
    dlog("Scanning slides for lazy elements...");
    slides = Array.from(document.querySelectorAll(cfg.slideSelector));
    
    const appLayoutNum = (typeof App !== 'undefined' && App.layout) ? App.layout.numImages : 0;
    slideCount = slides.length || appLayoutNum || 0;
    
    slideLazyMap = new Array(slideCount).fill(null).map(() => []);
    loadedFlags = new Array(slideCount).fill(false);

    for (let i = 0; i < slides.length; i++) {
      const slide = slides[i];
      const lazyEls = slide.querySelectorAll(cfg.lazyClass);
      if (!lazyEls || lazyEls.length === 0) continue;

      lazyEls.forEach((el) => {
        const tag = (el.tagName || "").toLowerCase();
        let type = "image";
        if (tag === "video" || el.querySelector && el.querySelector("source[data-video-src]")) {
          type = "video";
        } else if (tag === "img") {
          type = "image";
        } else {
          if (el.getAttribute(cfg.videoSourceAttr)) type = "video";
        }

        slideLazyMap[i].push({ el, type, loaded: false });
      });
    }
  }

  function preconnectOrigins() {
    if (!cfg.preconnectOrigins || cfg.preconnectOrigins.length === 0) return;
    cfg.preconnectOrigins.forEach(origin => {
      if (!document.querySelector(`link[href="${origin}"][rel="preconnect"]`)) {
        const l = document.createElement("link");
        l.rel = "preconnect";
        l.href = origin;
        document.head.appendChild(l);
      }
    });
  }

  function markLoaded(slideIndex, lazyItem) {
    lazyItem.loaded = true;
    const allDone = slideLazyMap[slideIndex].every(item => item.loaded || item.el.hasAttribute("data-lazy-skip"));
    if (allDone) loadedFlags[slideIndex] = true;
  }

/*   function loadImage(slideIndex, lazyItem) {
    const el = lazyItem.el;
    const dataSrc = el.getAttribute(cfg.highResAttr);
    const dataSrcset = el.getAttribute(cfg.highResSrcsetAttr);
    const low = el.getAttribute(cfg.placeholderAttrLow);

    if (!dataSrc && !dataSrcset) {
      markLoaded(slideIndex, lazyItem);
      return;
    }

    if (low && !el.getAttribute("src") && el.tagName.toLowerCase() === "img") {
      el.setAttribute("src", low);
    }

    const img = new Image();
    if (dataSrcset) img.srcset = dataSrcset;
    if (dataSrc) img.src = dataSrc;

    if (img.decode) {
        img.decode().then(() => {
            applyImage(el, dataSrc, dataSrcset, low);
            markLoaded(slideIndex, lazyItem);
        }).catch((encodingError) => {
            dlog("decode() error, falling back to standard load", encodingError);
            img.onload = () => {
                applyImage(el, dataSrc, dataSrcset, low);
                markLoaded(slideIndex, lazyItem);
            };
        });
    } else {
        img.onload = () => {
            applyImage(el, dataSrc, dataSrcset, low);
            markLoaded(slideIndex, lazyItem);
        };
    }

    img.onerror = () => {
      markLoaded(slideIndex, lazyItem);
    };
  } */

function loadImage(slideIndex, lazyItem) {
  const el = lazyItem.el;
  const dataSrc = el.getAttribute(cfg.highResAttr);
  const dataSrcset = el.getAttribute(cfg.highResSrcsetAttr);
  const low = el.getAttribute(cfg.placeholderAttrLow);

  if (!dataSrc && !dataSrcset) {
    markLoaded(slideIndex, lazyItem);
    return;
  }

  // Load low placeholder first if exists
  if (low && !el.getAttribute("src") && el.tagName.toLowerCase() === "img") {
    el.setAttribute("src", low);
  }

  // ✅ Important: attach events BEFORE setting high-res src
  const onLoad = () => {
    el.removeEventListener("load", onLoad);
    el.removeEventListener("error", onError);

    if (cfg.fadeInClass) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          el.classList.add(cfg.fadeInClass);
        });
      });
    }

    if (cfg.removeDataAttr) {
      el.removeAttribute(cfg.highResAttr);
      if (dataSrcset) el.removeAttribute(cfg.highResSrcsetAttr);
      if (low) el.removeAttribute(cfg.placeholderAttrLow);
    }

    markLoaded(slideIndex, lazyItem);
  };

  const onError = () => {
    el.removeEventListener("load", onLoad);
    el.removeEventListener("error", onError);
    markLoaded(slideIndex, lazyItem);
  };

  el.addEventListener("load", onLoad, { once: true });
  el.addEventListener("error", onError, { once: true });

  // ✅ Only now set high-res sources
  if (dataSrcset && el.tagName.toLowerCase() === "img") {
    el.setAttribute("srcset", dataSrcset);
  }
  if (dataSrc) {
    el.setAttribute("src", dataSrc);
  }
}




  function applyImage(el, src, srcset, lowPlaceholder) {
      try {
        if (srcset && el.tagName.toLowerCase() === "img") {
          el.setAttribute("srcset", srcset);
        }
        if (src) {
          el.setAttribute("src", src);
        }
        
        // [FIX] Double requestAnimationFrame
        // This ensures the browser paints the new SRC before we set opacity to 1.
        // This eliminates the "top-to-bottom scan" artifact on slow rendering.
        if (cfg.fadeInClass) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    el.classList.add(cfg.fadeInClass);
                });
            });
        }

        if (cfg.removeDataAttr) {
          el.removeAttribute(cfg.highResAttr);
          if (srcset) el.removeAttribute(cfg.highResSrcsetAttr);
          if (lowPlaceholder) el.removeAttribute(cfg.placeholderAttrLow);
        }
      } catch (err) {
        dlog("applyImage error", err);
      }
  }

  // [UPDATED] Handles Poster Pre-loading for independent fade-in
/*   function loadVideo(slideIndex, lazyItem) {
    const el = lazyItem.el;
    
    // 1. Handle Poster (Load & Fade independent of video data)
    const posterUrl = el.getAttribute(cfg.posterAttr);
    if (posterUrl) {
        // Preload poster image to ensure smooth fade
        const posterImg = new Image();
        posterImg.src = posterUrl;
        
        posterImg.onload = () => {
            el.poster = posterUrl;
            // Fade in as soon as poster is ready! 
            // Don't wait for video data.
            if (cfg.fadeInClass) {
                requestAnimationFrame(() => {
                    el.classList.add(cfg.fadeInClass);
                });
            }
            if (cfg.removeDataAttr) el.removeAttribute(cfg.posterAttr);
        };
        // Fallback: If poster fails, set it anyway, code below handles video fade
        posterImg.onerror = () => { el.poster = posterUrl; };
    }

    // 2. Find Sources
    let sourcesFound = false;
    if (el.tagName.toLowerCase() === "video") {
      const srcAttr = el.getAttribute(cfg.videoSourceAttr);
      const sources = el.querySelectorAll("source"); 
      
      if (sources.length > 0) {
        sources.forEach(source => {
            const url = source.getAttribute(cfg.videoSourceAttr);
            if (url) {
                source.src = url;
                if (cfg.removeDataAttr) source.removeAttribute(cfg.videoSourceAttr);
                sourcesFound = true;
            }
        });
      } else if (srcAttr) {
        el.src = srcAttr;
        if (cfg.removeDataAttr) el.removeAttribute(cfg.videoSourceAttr);
        sourcesFound = true;
      }
    } 

    if (sourcesFound) {
       el.load(); 
       
       el.onloadeddata = () => { 
           // Safety: Ensure fade class is added if poster didn't exist or failed
           if (cfg.fadeInClass && !el.classList.contains(cfg.fadeInClass)) {
               el.classList.add(cfg.fadeInClass); 
           }
           markLoaded(slideIndex, lazyItem); 
       };
       
       el.onerror = () => { 
           markLoaded(slideIndex, lazyItem); 
       };
       
       setTimeout(() => markLoaded(slideIndex, lazyItem), 3000);
    } else {
       markLoaded(slideIndex, lazyItem);
    }
  } */
  
  // [UPDATED] Video Logic with improved Poster handling matching Image logic
/*   function loadVideo(slideIndex, lazyItem) {
    const el = lazyItem.el;
    
    // 1. Handle Poster (Using proven logic from loadImage)
    const posterUrl = el.getAttribute(cfg.posterAttr);
    if (posterUrl) {
        // Create a dummy image to track the download of the poster
        const posterImg = new Image();
        
        posterImg.onload = () => {
            el.poster = posterUrl;
            
            // Apply fade-in specifically for the poster phase
            if (cfg.fadeInClass && !el.classList.contains(cfg.fadeInClass)) {
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        el.classList.add(cfg.fadeInClass);
                    });
                });
            }
            if (cfg.removeDataAttr) el.removeAttribute(cfg.posterAttr);
        };

        // If poster fails, just set it anyway and let the video load handle the fade
        posterImg.onerror = () => { el.poster = posterUrl; };
        
        // Trigger download
        posterImg.src = posterUrl;
    }

    // 2. Find Sources (Standard video logic)
    let sourcesFound = false;
    if (el.tagName.toLowerCase() === "video") {
      const srcAttr = el.getAttribute(cfg.videoSourceAttr);
      const sources = el.querySelectorAll("source"); 
      
      if (sources.length > 0) {
        sources.forEach(source => {
            const url = source.getAttribute(cfg.videoSourceAttr);
            if (url) {
                source.src = url;
                if (cfg.removeDataAttr) source.removeAttribute(cfg.videoSourceAttr);
                sourcesFound = true;
            }
        });
      } else if (srcAttr) {
        el.src = srcAttr;
        if (cfg.removeDataAttr) el.removeAttribute(cfg.videoSourceAttr);
        sourcesFound = true;
      }
    } 

    if (sourcesFound) {
       el.load(); 
       
       el.onloadeddata = () => { 
           // Safety: Ensure fade class is added if poster didn't exist/finish
           if (cfg.fadeInClass && !el.classList.contains(cfg.fadeInClass)) {
               requestAnimationFrame(() => {
                   requestAnimationFrame(() => {
                       el.classList.add(cfg.fadeInClass);
                   });
               });
           }
           markLoaded(slideIndex, lazyItem); 
       };
       
       el.onerror = () => { 
           markLoaded(slideIndex, lazyItem); 
       };
       
       setTimeout(() => markLoaded(slideIndex, lazyItem), 3000);
    } else {
       markLoaded(slideIndex, lazyItem);
    }
  } */
  
 
 function loadVideo(slideIndex, lazyItem) {
  const el = lazyItem.el;
  const sources = el.querySelectorAll("source");
  let sourcesFound = false;
  let finished = false;

  const finish = (reason) => {
    if (finished) return;
    finished = true;
    // final fade after paint
    if (cfg.fadeInClass && !el.classList.contains(cfg.fadeInClass)) {
      requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add(cfg.fadeInClass)));
    }
    if (cfg.removeDataAttr) {
      // clean up data attrs on sources and video
      sources.forEach(s => s.removeAttribute(cfg.videoSourceAttr));
      el.removeAttribute(cfg.videoSourceAttr);
    }
    markLoaded(slideIndex, lazyItem);
  };

  // attach robust event handlers BEFORE assigning srcs
  const onPlaying = () => finish("playing");
  const onCanPlayThrough = () => finish("canplaythrough");
  const onLoadedData = () => {
    // weaker fallback: give play() a moment, then finish if nothing else happens
    setTimeout(() => { if (!finished) finish("loadeddata-fallback"); }, 120);
  };
  const onError = () => finish("error");

  el.addEventListener("playing", onPlaying, { once: true });
  el.addEventListener("canplaythrough", onCanPlayThrough, { once: true });
  el.addEventListener("loadeddata", onLoadedData, { once: true });
  el.addEventListener("error", onError, { once: true });

  // Assign sources from data attribute and mark if found
  if (el.tagName.toLowerCase() === "video") {
    const srcAttr = el.getAttribute(cfg.videoSourceAttr);
    if (sources.length > 0) {
      sources.forEach(source => {
        const url = source.getAttribute(cfg.videoSourceAttr);
        if (url) {
          source.src = url;
          sourcesFound = true;
        }
      });
    } else if (srcAttr) {
      el.src = srcAttr;
      sourcesFound = true;
    }
  }

  if (sourcesFound) {
    // prefer browser to load enough to play
    try { el.preload = "auto"; } catch(e) {}
    try { el.load(); } catch(e) {}

    // Attempt autoplay for muted videos; if blocked, fallback events will handle it
    if (el.autoplay) {
      const p = el.play();
      if (p && p.catch) {
        p.catch(() => {
          // autoplay blocked; rely on event fallbacks
        });
      }
    }

    // Safety timeout so we never hang forever
    setTimeout(() => { if (!finished) finish("timeout"); }, 5000);
  } else {
    // nothing to load
    finish("nosources");
  }
}





  function loadSlide(slideIndex) {
    if (!slideLazyMap || slideLazyMap.length === 0) return;
    const items = slideLazyMap[slideIndex];
    if (!items || items.length === 0) {
      loadedFlags[slideIndex] = true;
      return;
    }
    items.forEach(item => {
      if (item.loaded) return;
      if (item.type === "image") {
        loadImage(slideIndex, item);
      } else if (item.type === "video") {
        loadVideo(slideIndex, item);
      } else {
        loadImage(slideIndex, item);
      }
    });
  }

  function computeLoadRange(targetIndex) {
    const activeCount = Math.max(1, slideCount || (App.layout ? App.layout.numImages : 0) || 0);
    const lookAhead = Math.max(0, Math.floor(cfg.lookahead));
    const lookBehind = cfg.bidirectional ? Math.max(0, Math.floor(cfg.lookbehind)) : 0;

    const indices = new Set();
    
    for (let k = -lookBehind; k <= lookAhead; k++) {
      const wrappedIndex = gsap.utils.wrap(0, activeCount, targetIndex + k);
      indices.add(wrappedIndex);
    }
    return Array.from(indices);
  }

  function process(targetIndex, lastIndex) {
    if (!initialized || document.querySelectorAll(cfg.slideSelector).length !== slideCount) {
      scanSlides();
      preconnectOrigins();
      initialized = true;
    }

    if (!slideCount || slideCount === 0) {
      const appLayoutNum = (typeof App !== 'undefined' && App.layout) ? App.layout.numImages : 0;
      slideCount = slides.length || appLayoutNum || 0;
    }

    let target = (typeof targetIndex === "number") ? targetIndex : null;
    if (target === null) {
      try {
        const p = (typeof App !== 'undefined' && App.progress) ? App.progress.value : 0;
        const idx = Math.round((p % 1 + 1) % 1 * (slideCount || 1));
        target = gsap.utils.wrap(0, slideCount, idx);
      } catch (err) {
        target = 0;
      }
    }

    if (lastProcessedTarget === target) {
      return;
    }
    lastProcessedTarget = target;

    dlog("process: target:", target);

    const toLoad = computeLoadRange(target);

    // Debounced Loading Execution
    if (loadTimer) clearTimeout(loadTimer);

    const executeLoad = () => {
        toLoad.forEach(i => {
          if (!loadedFlags[i]) {
            dlog(" -> loading slide", i);
            loadSlide(i);
          } else {
            dlog(" -> already loaded slide", i);
          }
        });
    };

    if (cfg.loadDelay > 0 && target !== 0) {
        loadTimer = setTimeout(executeLoad, cfg.loadDelay);
    } else {
        executeLoad();
    }
  }

  /////////////////////// MODULE LOGIC END ///////////////////////

  setTimeout(() => {
      if (lastProcessedTarget === null) {
          process(0);
      }
  }, 100);

  return {
    config: cfg,
    setConfig: (newCfg) => {
      cfg = Object.assign(cfg, newCfg || {});
      dlog("config updated", cfg);
    },
    process,
    forceProcess: () => {
      lastProcessedTarget = null;
      process();
    },
    _internal: {
      scanSlides,
      slideLazyMap,
      loadedFlags
    }
  };
}